/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * MaterialRounded History.
 */
export const ICON_HISTORY = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.4041 3.00184C8.31407 2.86184 4.14407 6.95184 4.14407 12.0018H2.35407C1.90407 12.0018 1.68407 12.5418 2.00407 12.8518L4.79407 15.6518C4.99407 15.8518 5.30407 15.8518 5.50407 15.6518L8.29407 12.8518C8.60407 12.5418 8.38407 12.0018 7.93407 12.0018H6.14407C6.14407 8.10184 9.32407 4.95184 13.2441 5.00184C16.9641 5.05184 20.0941 8.18184 20.1441 11.9018C20.1941 15.8118 17.0441 19.0018 13.1441 19.0018C11.5341 19.0018 10.0441 18.4518 8.86407 17.5218C8.46407 17.2118 7.90407 17.2418 7.54407 17.6018C7.12407 18.0218 7.15407 18.7318 7.62407 19.0918C9.14407 20.2918 11.0541 21.0018 13.1441 21.0018C18.1941 21.0018 22.2841 16.8318 22.1441 11.7418C22.0141 7.05184 18.0941 3.13184 13.4041 3.00184ZM12.8941 8.00184C12.4841 8.00184 12.1441 8.34184 12.1441 8.75184V12.4318C12.1441 12.7818 12.3341 13.1118 12.6341 13.2918L15.7541 15.1418C16.1141 15.3518 16.5741 15.2318 16.7841 14.8818C16.9941 14.5218 16.8741 14.0618 16.5241 13.8518L13.6441 12.1418V8.74184C13.6441 8.34184 13.3041 8.00184 12.8941 8.00184Z"
      fill="#3D3D3D"
    />
  </svg>
);
